export const MOBILE_APP_ROUTE_POLICY = {
  trainEntryPath: "/train",
  preferredPracticePath: "/practice",
} as const;
